module.exports = __webpack_public_path__ + "static/media/NX-logo-background.472677c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NX-logo-background.png
// module id = 283
// module chunks = 0